import confetti from './confetti.module';

export class Confetti
{
	static fire = confetti;
	static create = confetti.create;
}